
















































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { STATUSES as SERVICE_CANDIDATE_STATUSES } from '@/constants/service_candidate';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import ServiceCandidateListFilterForm from './List/ServiceCandidateListFilterForm.vue';
import ServiceCandidateListFilterChip from './List/ServiceCandidateListFilterChip.vue';

@Component({
  components: {
    ServiceCandidateListFilterForm,
    ServiceCandidateListFilterChip,
  },
  computed: {
    ...mapState('Auth', {
      activeKeys: 'activeKeys',
    }),
  },
})
export default class ServiceCandidateList extends Vue {
  isMounted = false;
  isLoading = false;
  reload = 0;
  options: ServiceCandidateListFilterOptions = {
    page: 1,
    itemsPerPage: 10,
    query: null,
    orderBy: null,
    orderByDirection: 'asc',
    statuses: [
      SERVICE_CANDIDATE_STATUSES.STATUS_ONGOING.key,
      SERVICE_CANDIDATE_STATUSES.STATUS_PROCESSING.key,
    ],
    bookingCandidateStatuses: [BOOKING_CANDIDATE_STATUSES.STATUS_COMPLETED.key],
    candidateName: null,
    serviceItemOid: null,
  };
  serviceCandidateStatuses = SERVICE_CANDIDATE_STATUSES;
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;

  serviceItems!: Model[];
  activeKeys!: string[];
  serviceItemOid: string | undefined = '';

  headers = [
    { text: 'ID', value: 'object_id' },
    {
      text: 'Service',
      value: 'service_item.name',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Candidate',
      value: 'booking_candidate',
      align: 'left',
      sortable: false,
    },
    {
      text: 'Business',
      value: 'service_request.business.name',
      align: 'left',
      sortable: false,
    },
    { text: 'Status', value: 'status', align: 'left', sortable: false },
    {
      text: 'Actions',
      value: 'actions',
      align: 'left',
      sortable: false,
      width: '15%',
      cellClass: 'row-click-stop',
    },
  ];

  beforeMount() {
    if (!this.canAssessor && !this.canDoctor) {
      this.$router.push({
        name: '403',
      });
    }
    this.$store.dispatch('ServiceItem/fetchList').then((response) => {
      this.serviceItems = response.data.data;
      if (this.canAssessor && !this.canDoctor) {
        const serviceItem = this.serviceItems.find(
          (item) => item.key === 'assessor_response'
        );
        this.serviceItemOid = serviceItem?.object_id;
      }

      if (!this.canAssessor && this.canDoctor) {
        const serviceItem = this.serviceItems.find(
          (item) => item.key === 'doctor_response'
        );
        this.serviceItemOid = serviceItem?.object_id;
      }
      this.options['serviceItemOid'] = this.serviceItemOid
        ? this.serviceItemOid
        : null;
      this.isMounted = true;
    });
  }

  handleFetch() {
    const options = {
      params: {
        search: this.options.query,
        page: this.options.page,
        per_page: this.options.itemsPerPage,
        sort:
          this.options.orderByDirection == 'desc'
            ? '-' + this.options.orderBy
            : this.options.orderBy,
        statuses: this.options.statuses,
        booking_candidate_statuses: this.options.bookingCandidateStatuses,
        candidate_name: this.options.candidateName,
        service_item_oid: this.options.serviceItemOid,
        expand: [
          'booking_candidate',
          'service_item',
          'service_request.business',
        ],
      },
    };
    return this.$store.dispatch('ServiceCandidate/fetchList', options);
  }

  toRead(oid) {
    this.$router.push({
      name: 'admin-service-candidate-read',
      params: {
        serviceCandidateOid: oid,
      },
    });
  }

  pickup(oid) {
    this.isLoading = true;
    this.$store
      .dispatch('ServiceCandidate/pickup', oid)
      .then(() => {
        this.$router.push({
          name: 'admin-service-candidate-read',
          params: {
            serviceCandidateOid: oid,
          },
        });
      })
      .catch(({ response }) => {
        this.$store.commit('SET_SNACKBAR', {
          show: true,
          type: 'error',
          message: response.data.error,
        });
        this.isLoading = false;
      });
  }

  canPickup(item) {
    return (
      !item.pickup_by_user &&
      item.status == this.serviceCandidateStatuses.STATUS_ONGOING.key &&
      item.booking_candidate.status ==
        this.bookingCandidateStatuses.STATUS_COMPLETED.key
    );
  }

  get canAssessor() {
    if (this.activeKeys.includes('kAssessorResponseProcess')) {
      return true;
    }

    return false;
  }

  get canDoctor() {
    if (this.activeKeys.includes('kDoctorSignoffProcess')) {
      return true;
    }

    return false;
  }

  handleClick(item) {
    this.toRead(item.object_id);
  }
}
